<mat-icon
  class="file-drag-drop_status"
  [class.file-drag-drop_status--error]="error && !!file"
  [class.file-drag-drop_status--success]="!!file"
  [icon]="error && !!file ? 'circle-alert' : !!file ? 'check-circle' : 'upload'"
  [iconSize]="24" />

@if (showNewVersionLabel) {
  <div class="file-drag-drop_new-version-label">
    {{ 'FileDragDrop.UploadNewVersion' | transloco }}
  </div>
}

@if (!file) {
  <div class="file-drag-drop_select">
    @if (invalidExtension()) {
      <div class="file-drag-drop_info file-drag-drop_info--error">
        {{ 'FileDragDrop.InvalidExtension' | transloco: { extension: invalidExtension() } }}
      </div>
    }
    <span class="file-drag-drop_info"
      >{{ info | transloco }}
      <span class="file-drag-drop_info--action" (click)="selectFile()">{{ 'FileDragDrop.Select' | transloco }}</span></span
    >
  </div>
} @else {
  <div class="file-drag-drop_change">
    @if (error) {
      <div class="file-drag-drop_info file-drag-drop_info--error">{{ error }}</div>
    } @else {
      <span class="file-drag-drop_info">{{ 'FileDragDrop.FileUploadSuccessful' | transloco }}</span>
    }
    <span class="file-drag-drop_filename" [ttTooltip]="file.name">{{ file.name }}</span>

    <span class="file-drag-drop_actions">
      <span class="file-drag-drop_action" (click)="selectFile()">{{ 'FileDragDrop.ChangeFile' | transloco }}</span>
      <span class="file-drag-drop_action" (click)="delete()">{{ 'FileDragDrop.Delete' | transloco }}</span>
    </span>
  </div>
}
